export enum InviteCategory {
    PersonalStepsInvite = 'PersonalStepsInvite',
    PersonalHHInvite = 'PersonalHHInvite',
    PromotedHHInvite = 'PromotedHHInvite',
    SpotlightInvite = 'SpotlightInvite',
    BasicStepsInvite = 'BasicStepsInvite',
    DestinationStepsInvite = 'DestinationStepsInvite',
    StagedStepsInvite = 'StagedStepsInvite'
}
